import React, { useEffect, useState } from 'react';
export function ProductSection() {
  const [tiempo, setTiempo] = useState(15 * 60);
  const [viewers, setViewers] = useState(108);
  useEffect(() => {
    const intervalo = setInterval(() => {
      setTiempo(t => t > 0 ? t - 1 : 0);
    }, 1000);
    return () => clearInterval(intervalo);
  }, []);
  useEffect(() => {
    const intervalo = setInterval(() => {
      setViewers(Math.floor(Math.random() * (115 - 100 + 1)) + 100);
    }, 2000);
    return () => clearInterval(intervalo);
  }, []);
  const minutos = String(Math.floor(tiempo / 60)).padStart(2, '0');
  const segundos = String(tiempo % 60).padStart(2, '0');
  return <section style={{
    background: '#FFFFFF',
    padding: '28px 18px 32px',
    textAlign: 'center',
    fontFamily: "'Segoe UI', sans-serif"
  }} data-id="element-25">
      {/* Imagen producto */}
      <div style={{
      marginBottom: '0'
    }} data-id="element-26">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772527782/ChatGPT_Image_3_mar_2026_09_49_24_vqgjet.png" alt="Producto" style={{
        width: '100%',
        maxWidth: '320px',
        display: 'block',
        margin: '0 auto 14px auto',
        borderRadius: '18px'
      }} data-id="element-27" />
      </div>

      {/* Descargas */}
      <p style={{
      fontSize: '13px',
      color: '#6b7280',
      marginBottom: '8px'
    }} data-id="element-28">
        +5.200 descargas
      </p>

      {/* Título */}
      <p style={{
      fontSize: '19px',
      fontWeight: 700,
      lineHeight: 1.25,
      marginBottom: '18px',
      color: '#065F5B'
    }} data-id="element-29">
        Biohacking + 800 recetas diseñadas para llenarte de energía y vitalidad{' '}
        <span style={{
        color: '#14B8A6',
        fontWeight: 800
      }} data-id="element-30">
          + 6 BONOS
        </span>
      </p>

      {/* Tarjeta precio */}
      <div style={{
      background: '#F0FDFA',
      borderRadius: '16px',
      padding: '18px 16px',
      border: '1px solid rgba(20,184,166,0.18)',
      boxShadow: '0 18px 40px rgba(0,0,0,0.10)',
      marginBottom: '14px'
    }} data-id="element-31">
        <p style={{
        color: '#DC2626',
        textDecoration: 'line-through',
        fontSize: '15px',
        marginBottom: '6px'
      }} data-id="element-32">
          54.95€
        </p>
        <p style={{
        fontSize: '32px',
        fontWeight: 800,
        color: '#065F5B',
        marginBottom: '4px'
      }} data-id="element-33">
          14.95€
        </p>
        <p style={{
        color: '#14B8A6',
        fontWeight: 600,
        fontSize: '14px',
        marginBottom: '12px'
      }} data-id="element-34">
          AHORRA 50€
        </p>
        <div style={{
        height: '1px',
        background: '#d1d5db',
        margin: '12px 0'
      }} data-id="element-35" />
        <p style={{
        fontSize: '12px',
        color: '#374151'
      }} data-id="element-36">
          🔒 Compra segura | ⚡ Acceso instantáneo
        </p>
      </div>

      {/* Tarjeta urgencia */}
      <div style={{
      background: '#ECFDF5',
      borderRadius: '16px',
      padding: '18px 16px',
      border: '1px solid rgba(20,184,166,0.18)',
      boxShadow: '0 18px 40px rgba(0,0,0,0.10)',
      marginBottom: '14px'
    }} data-id="element-37">
        <p style={{
        fontWeight: 800,
        fontSize: '15px',
        color: '#065F5B',
        marginBottom: '8px'
      }} data-id="element-38">
          ¡OFERTA SOLO POR HOY!
        </p>
        <p style={{
        fontSize: '13px',
        marginBottom: '10px',
        lineHeight: 1.35,
        color: '#374151'
      }} data-id="element-39">
          Tu lugar con los <strong data-id="element-40">6 bonos de regalo</strong> solo está
          reservado por los próximos minutos. No pierdas tus beneficios.
        </p>
        <p style={{
        fontSize: '12px',
        marginBottom: '4px'
      }} data-id="element-41">
          La oferta termina en:
        </p>
        <p style={{
        fontSize: '22px',
        fontWeight: 800,
        color: '#065F5B'
      }} data-id="element-42">
          {minutos}:{segundos}
        </p>
      </div>

      {/* Social proof */}
      <p style={{
      fontSize: '13px',
      marginBottom: '8px',
      color: '#374151'
    }} data-id="element-43">
        <span style={{
        height: '9px',
        width: '9px',
        borderRadius: '50%',
        display: 'inline-block',
        marginRight: '6px',
        background: '#22C55E',
        boxShadow: '0 0 10px rgba(34,197,94,0.7)',
        animation: 'blink 1s infinite',
        verticalAlign: 'middle'
      }} data-id="element-44" />
        <span data-id="element-45">{viewers}</span> personas están viendo esta oferta ahora mismo
      </p>
      <p style={{
      fontSize: '13px',
      marginBottom: '8px',
      color: '#374151'
    }} data-id="element-46">
        <span style={{
        height: '9px',
        width: '9px',
        borderRadius: '50%',
        display: 'inline-block',
        marginRight: '6px',
        background: '#EF4444',
        boxShadow: '0 0 10px rgba(239,68,68,0.7)',
        animation: 'blink 1s infinite',
        verticalAlign: 'middle'
      }} data-id="element-47" />
        Últimos 5 cupos disponibles
      </p>

      {/* Botón CTA */}
      <a href="https://infoliar.com/cart/56888491966796:1" style={{
      display: 'block',
      width: '100%',
      background: 'linear-gradient(90deg, #0F766E, #14B8A6)',
      color: 'white',
      fontWeight: 800,
      padding: '15px',
      borderRadius: '50px',
      textDecoration: 'none',
      marginTop: '14px',
      boxShadow: '0 10px 25px rgba(20,184,166,0.35)',
      animation: 'breathing 2.5s infinite ease-in-out',
      boxSizing: 'border-box'
    }} data-id="element-48">
        GUIA PRE Y POST-MENOPAUSIA
      </a>
    </section>;
}